module.exports = __webpack_public_path__ + "static/media/freight.61e09115.xlsx";